module.exports = __webpack_public_path__ + "media/images/undraw/shift/connected-bd852f5a1e5271809a0cd29545ae5771.png";